import {Bewertung} from '../v2024';

export const BewertungEnumLabels = {
    _1: '1' as Bewertung,
    _2: '2' as Bewertung,
    _3: '3' as Bewertung,
    _4: '4' as Bewertung,
    _5: '5' as Bewertung
};

